import Cookies from 'js-cookie'
import Agent, { compareVersion } from '../agent'

export enum webpSupportedStatus {
  domainNotSupport = -1,
  notSupport = 0,
  support = 1,
  knbMediaSupport = 2,
}

const webpOriginSupported =
  !![].map && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0

const nativeWebpSupported = (() => {
  if (Agent.native) {
    if (Agent.wkwebview) {
      // 点评某些版本使用 TitansNoX 临时表达同样含义，用于避免 KNB JS 自动载入 Titans 实现
      if (compareVersion(Agent.uaInfo.titansx || Agent.uaInfo.titansnox || '', '11.12.5.10') > 0) {
        if (compareVersion(Agent.uaInfo.ios || '', '11.0.0') > 0) {
          return webpSupportedStatus.knbMediaSupport
        }
      }
      return webpSupportedStatus.notSupport
    }
    return webpSupportedStatus.support
  }
  return webpOriginSupported ? webpSupportedStatus.support : webpSupportedStatus.notSupport
})()

export default function isWebpSupported(url: string): webpSupportedStatus {
  const cookieSupportStatus: string | undefined = Cookies.get('phx_webpcache')
  let supportStatus: webpSupportedStatus
  if (cookieSupportStatus) {
    return parseInt(cookieSupportStatus)
  }
  if (url.indexOf('sankuai') === -1 && url.indexOf('meituan') === -1) {
    // 非公司
    supportStatus = webpSupportedStatus.domainNotSupport
  }
  supportStatus = nativeWebpSupported
  Cookies.set('phx_webpcache', String(supportStatus), { expires: 7 })
  // console.log('[webp]', supportStatus)
  return supportStatus
}
